import React, { forwardRef } from "react";
import { Avatar, AvatarProps } from "../../avatar";
import { BaseChip } from "../components/BaseChip";
import { SharedChipProps } from "../types";

export interface AvatarChipProps extends SharedChipProps {
    /**
     * Props for rendering the Avatar left of the chip text.
     */
    avatarProps: Omit<AvatarProps, "tabIndex" | "size">;
}

export const AvatarChip = forwardRef<HTMLDivElement, AvatarChipProps>(({ avatarProps, ...rest }, ref) => {
    return (
        <BaseChip
            {...rest}
            ref={ref}
            color="neutral"
            contentBefore={<Avatar {...avatarProps} aria-hidden role="presentation" tabIndex={-1} size="xxSmall" />}
        />
    );
});

AvatarChip.displayName = "AvatarChip";
